var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotesAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.7,
    height: 28,
    viewBox: "0 0 23.7 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3746",
    "data-name": "Group 3746",
    transform: "translate(-1051 -359.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prologis-icon",
    d: "M28.385,11.844V17.2a.886.886,0,0,0,.764.885l.11.007H34.5V34.165a2.656,2.656,0,0,1-2.457,2.674l-.166.005H17.9a2.646,2.646,0,0,1-2.617-2.509l-.005-.17V14.523a2.655,2.655,0,0,1,2.457-2.674l.165-.005H28.385ZM27.261,29.151H17.2v1.923H27.261V29.151Zm3.4-3.846H17.2v1.923h13.46V25.305ZM32.58,21.46H17.2v1.923H32.579V21.46Zm-2.447-9.092,3.858,3.941H30.133V12.367Z",
    transform: "translate(1035.727 347.656)",
    fill: "#2c728a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3738",
    "data-name": "Group 3738",
    transform: "translate(1062.7 375.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_389",
    "data-name": "Path 389",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 11.5 C 2.967289924621582 11.5 0.5 9.032710075378418 0.5 6 C 0.5 2.967289924621582 2.967289924621582 0.5 6 0.5 C 9.032710075378418 0.5 11.5 2.967289924621582 11.5 6 C 11.5 9.032710075378418 9.032710075378418 11.5 6 11.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 1 C 3.242989540100098 1 1 3.242989540100098 1 6 C 1 8.757009506225586 3.242989540100098 11 6 11 C 8.757009506225586 11 11 8.757009506225586 11 6 C 11 3.242989540100098 8.757009506225586 1 6 1 M 6 0 C 9.31371021270752 0 12 2.68628978729248 12 6 C 12 9.31371021270752 9.31371021270752 12 6 12 C 2.68628978729248 12 0 9.31371021270752 0 6 C 0 2.68628978729248 2.68628978729248 0 6 0 Z",
    stroke: "none",
    fill: "#2c728a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299",
    transform: "translate(3.135 3.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M18,7.5v5.728",
    transform: "translate(-15.136 -7.5)",
    fill: "none",
    stroke: "#2c728a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M7.5,18h5.728",
    transform: "translate(-7.5 -15.136)",
    fill: "none",
    stroke: "#2c728a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesAdd);
export default __webpack_public_path__ + "static/media/notes_add.79616185d7a6f44887afb84e33e76e04.svg";
export { ForwardRef as ReactComponent };